var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"externalPage"},[(_vm.url)?_vm._m(0):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url,"frameborder":"0"}})
}]

export { render, staticRenderFns }